/* PDP sticky add-to-cart bar — vanilla JS, no dependencies.
 * Remote control for the real product form (see snippets/pdp-sticky-bar.liquid):
 *  - "Black  Change": "Change" IS a visible native <select> whose shown option is always "Change";
 *    its list mirrors the real colour radios (current one marked) and picking one clicks the radio
 *    (variant engine does the rest). No invisible overlay, so contrast checkers see real text.
 *  - typed quantity mirrors the real [name="quantity"] input
 *  - the button presses whichever real button is visible (Add to cart / Pre-Order / MOQ popup /
 *    Notify me) and shows the total, or "each" when the product has quantity-break pricing
 * Shown only after the price has scrolled above the viewport AND the real button is off screen.
 */
(function () {
  'use strict';

  /* Total in the buttons = unit price x quantity. Set to true to show "$x each" instead on products
     with a WSAIO quantity-break table (tier prices are applied in the cart, not on this page). */
  var EACH_WHEN_QTY_BREAKS = false;

  var TOTAL_SEP = ' \u00b7 '; // " · "

  function textWithoutHidden(el) {
    if (!el) return '';
    var clone = el.cloneNode(true);
    clone.querySelectorAll('.visually-hidden, .pdp-btn-total').forEach(function (n) { n.remove(); });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  /* button label without a total we added earlier: "Add to cart · $9.14" -> "Add to cart" */
  function baseLabel(el) {
    var t = textWithoutHidden(el);
    var i = t.indexOf(TOTAL_SEP.trim());
    return i > -1 ? t.slice(0, i).trim() : t;
  }

  /* "$1,234.50" -> { value: 1234.5, before: "$", after: "" } */
  function parseMoney(text) {
    var m = (text || '').match(/[0-9][0-9.,]*/);
    if (!m) return null;
    var raw = m[0];
    var num = raw;
    if (raw.indexOf(',') > -1 && raw.indexOf('.') > -1) num = raw.replace(/,/g, '');
    else if (/,\d{2}$/.test(raw)) num = raw.replace(/\./g, '').replace(',', '.');
    else num = raw.replace(/,/g, '');
    var value = parseFloat(num);
    if (isNaN(value)) return null;
    return { value: value, before: text.slice(0, m.index), after: text.slice(m.index + raw.length) };
  }

  function formatMoney(p, value) {
    var fixed = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (p.before + fixed + p.after).trim();
  }

  /* Quantity breaks (Wholesale All In One table). Reads the tiers shown on the page — minimum
     quantity + unit price (or "% off") — and returns the unit price for qty, or null when there is
     no table / no matching tier (then the page price is used, as before). Works whether the table
     lists tiers in rows or in columns. */
  function cellsOf(table) {
    return [].slice.call(table.querySelectorAll('tr')).map(function (r) {
      return [].slice.call(r.querySelectorAll('th, td')).map(function (c) {
        return (c.textContent || '').replace(/\s+/g, ' ').trim();
      });
    });
  }
  function transpose(grid) {
    var out = [];
    grid.forEach(function (row) {
      row.forEach(function (txt, i) { (out[i] = out[i] || []).push(txt); });
    });
    return out;
  }
  function tiersFrom(grid, base) {
    var tiers = [];
    grid.forEach(function (cells) {
      var min = null;
      var price = null;
      cells.forEach(function (txt) {
        if (!txt) return;
        var cur = txt.search(/[$€£]/);
        if (price === null && cur > -1) {
          var pm = parseMoney(txt.slice(cur));
          // "$0.09 off" / "Save $0.09" = an amount off the base price, not the price itself
          if (pm) price = (/\boff\b|save/i.test(txt) && base) ? base.value - pm.value : pm.value;
        } else if (price === null && /%/.test(txt) && base) {
          var pc = txt.match(/(\d+(?:\.\d+)?)\s*%/);
          if (pc) price = base.value * (1 - parseFloat(pc[1]) / 100);
        } else if (min === null && /\d/.test(txt)) {
          var mq = txt.match(/\d[\d,]*/);
          if (mq) min = parseInt(mq[0].replace(/,/g, ''), 10);
        }
      });
      if (min !== null && price !== null && price > 0) tiers.push({ min: min, price: price });
    });
    return tiers;
  }
  function tierPrice(section, qty, base) {
    var table = section.querySelector('#wsaio-volume-discount--table, .wholesale-wsaio-table table');
    if (!table) return null;
    var grid = cellsOf(table);
    var tiers = tiersFrom(grid, base);
    if (tiers.length < 2) tiers = tiersFrom(transpose(grid), base); // tiers laid out in columns
    if (!tiers.length) return null;
    var pick = null;
    tiers.forEach(function (t) { if (qty >= t.min && (!pick || t.min > pick.min)) pick = t; });
    return pick ? pick.price : null;
  }

  function isShown(el) {
    return !!el && !el.hidden && !el.classList.contains('hidden') && el.offsetParent !== null;
  }

  function PdpBar(bar) {
    this.bar = bar;
    this.sid = bar.getAttribute('data-section-id');
    this.select = bar.querySelector('[data-pdp-bar-pick]');
    this.pickValue = bar.querySelector('[data-pdp-bar-pickvalue]');
    this.thumb = bar.querySelector('[data-pdp-bar-thumb]');
    this.qty = bar.querySelector('[data-pdp-bar-qty]');
    this.btn = bar.querySelector('[data-pdp-bar-btn]');
    this.btnLabel = bar.querySelector('[data-pdp-bar-btnlabel]');
    this.btnPrice = bar.querySelector('[data-pdp-bar-btnprice]');
    this.narrow = window.matchMedia('(max-width: 749px)');
    this.passedPrice = false;
    this.atcVisible = true;
    this.observed = { price: null, submit: null };
    this.syncQueued = false;
    this.optionsKey = '';

    this.io = new IntersectionObserver(this.onIntersect.bind(this), { threshold: 0 });
    this.bindEvents();
    this.ensureObserved();
    this.sync();

    // Also measure positions directly. The observer only reports CHANGES, so after a refresh in the
    // middle of the page (the browser restores the scroll position) the price can go from "below the
    // screen" to "above the screen" without ever "changing" — and the bar never appeared.
    var self = this;
    var queued = false;
    var recheck = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; self.measure(); });
    };
    window.addEventListener('scroll', recheck, { passive: true });
    window.addEventListener('resize', recheck);
    window.addEventListener('load', recheck);
    window.addEventListener('pageshow', recheck);
    recheck();
  }

  /* Where are the price and the real button right now? (2 measurements, once per frame at most) */
  PdpBar.prototype.measure = function () {
    this.ensureObserved();
    var price = this.observed.price;
    var submit = this.observed.submit;
    if (!price || !submit) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var p = price.getBoundingClientRect();
    var a = submit.getBoundingClientRect();
    this.passedPrice = p.bottom < 0;
    this.atcVisible = a.bottom > 0 && a.top < vh;
    this.setShown(this.passedPrice && !this.atcVisible);
  };

  PdpBar.prototype.section = function () {
    return document.getElementById('ProductSection-' + this.sid);
  };

  PdpBar.prototype.form = function () {
    var s = this.section();
    return s ? s.querySelector('#AddToCartForm-' + this.sid) || s.querySelector('form[action*="/cart/add"]') : null;
  };

  /* The quantity box the shopper actually uses. Apps can add their own hidden
     [name="quantity"] inputs to the form, so the visible one inside the quantity block wins. */
  PdpBar.prototype.mainQty = function () {
    var f = this.form();
    if (!f) return null;
    var inBlock = f.querySelectorAll('.product-form__item--quantity input[name="quantity"], .product-form__item--quantity .js-qty__input');
    for (var i = 0; i < inBlock.length; i++) {
      if (inBlock[i].type !== 'hidden' && inBlock[i].offsetParent !== null) return inBlock[i];
    }
    var all = f.querySelectorAll('input[name="quantity"]');
    for (var j = 0; j < all.length; j++) {
      if (all[j].type !== 'hidden') return all[j];
    }
    return inBlock[0] || all[0] || null;
  };

  /* The real control the bar button should press. */
  PdpBar.prototype.target = function () {
    var s = this.section();
    if (!s) return null;
    var bis = s.querySelector('.product-form__item--submit .bis-button');
    if (isShown(bis)) return { el: bis, notify: true };
    var main = s.querySelector('.product-form__item--submit .product-form-btn');
    return main ? { el: main, notify: false } : null;
  };

  /* Observe the price block and the real button; re-attach if a full section swap replaced them. */
  PdpBar.prototype.ensureObserved = function () {
    var s = this.section();
    if (!s) return;
    var price = s.querySelector('[data-section-part="price"]');
    var submit = s.querySelector('.product-form__item--submit');
    if (price && price !== this.observed.price) {
      if (this.observed.price) this.io.unobserve(this.observed.price);
      this.io.observe(price);
      this.observed.price = price;
    }
    if (submit && submit !== this.observed.submit) {
      if (this.observed.submit) this.io.unobserve(this.observed.submit);
      this.io.observe(submit);
      this.observed.submit = submit;
    }
  };

  PdpBar.prototype.onIntersect = function (entries) {
    var self = this;
    entries.forEach(function (e) {
      if (e.target === self.observed.price) self.passedPrice = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (e.target === self.observed.submit) self.atcVisible = e.isIntersecting;
    });
    this.setShown(this.passedPrice && !this.atcVisible);
  };

  PdpBar.prototype.setShown = function (show) {
    var visible = !this.bar.hidden;
    if (show === visible) return;
    if (show) {
      this.sync();
      this.bar.hidden = false;
      document.body.classList.add('has-pdp-bar');
      document.documentElement.style.setProperty('--pdp-bar-h', this.bar.offsetHeight + 'px');
    } else {
      // don't strand keyboard focus on a control that is about to disappear
      var focusInBar = this.bar.contains(document.activeElement);
      this.bar.hidden = true;
      document.body.classList.remove('has-pdp-bar');
      if (focusInBar) {
        var t = this.target();
        if (t && t.el) t.el.focus({ preventScroll: true });
      }
    }
  };

  /* ---------- keep the bar in step with the real form ---------- */
  PdpBar.prototype.queueSync = function () {
    if (this.syncQueued) return;
    this.syncQueued = true;
    var self = this;
    requestAnimationFrame(function () {
      self.syncQueued = false;
      self.ensureObserved();
      self.sync();
    });
  };

  PdpBar.prototype.colourRadios = function () {
    var s = this.section();
    if (!s) return [];
    return Array.prototype.filter.call(
      s.querySelectorAll('.ColorSwatchGrid input[type="radio"]'),
      function (r) { return !r.hidden; }
    );
  };

  PdpBar.prototype.sync = function () {
    var s = this.section();
    if (!s) return;

    // colour list (rebuilt only when the set of colours changes)
    if (this.select) {
      var radios = this.colourRadios();
      var checked = radios.filter(function (r) { return r.checked; })[0];
      var key = radios.map(function (r) { return r.id + (r.getAttribute('aria-label') || '') + (r.checked ? '*' : ''); }).join('|');
      if (key !== this.optionsKey) {
        this.optionsKey = key;
        var frag = document.createDocumentFragment();
        var head = document.createElement('option'); // what the closed select shows
        head.value = '';
        head.textContent = 'Change';
        head.disabled = true;
        head.hidden = true;
        frag.appendChild(head);
        radios.forEach(function (r) {
          var o = document.createElement('option');
          o.value = r.id;
          var oos = /out of stock/i.test(r.getAttribute('aria-label') || '');
          o.textContent = r.value + (r.checked ? ' (selected)' : '') + (oos ? ' (out of stock)' : '');
          frag.appendChild(o);
        });
        this.select.replaceChildren(frag);
      }
      this.select.selectedIndex = 0;
      this.select.setAttribute('aria-label', 'Change colour' + (checked ? ', now ' + checked.value : ''));
      if (checked && this.thumb) {
        var img = s.querySelector('label[for="' + CSS.escape(checked.id) + '"] img');
        if (img && img.getAttribute('src') && this.thumb.getAttribute('src') !== img.getAttribute('src')) {
          this.thumb.setAttribute('src', img.getAttribute('src'));
        }
      }
    }

    // "Your pick" text (all options, e.g. "Black" or "Black • L")
    if (this.pickValue) {
      var txt = textWithoutHidden(s.querySelector('.variant_onchange'));
      if (txt && this.pickValue.textContent !== txt) this.pickValue.textContent = txt;
    }

    // quantity
    var mq = this.mainQty();
    if (mq && document.activeElement !== this.qty && this.qty.value !== mq.value) this.qty.value = mq.value;

    // button: real button's label + total (or "each" with quantity breaks, or no price for Notify me)
    var t = this.target();
    if (t) {
      var label = t.notify ? 'Notify me' : baseLabel(t.el);
      // same wording as the main button on every screen size ("Add to Cart", never shortened)
      if (label && this.btnLabel.textContent !== label) this.btnLabel.textContent = label;

      var priceText = '';
      var unit = this.unitPrice(s);
      if (!t.notify && unit) {
        var hasBreaks = EACH_WHEN_QTY_BREAKS && !!s.querySelector('#wsaio-volume-discount--table, .wholesale-wsaio-table table');
        var q = parseInt(mq ? mq.value : this.qty.value, 10) || parseInt(this.qty.value, 10) || 1;
        // products with the Wholesale All In One quantity-break table: unit price of the tier for q
        // (e.g. 48+ → $2.91); everything else: the page price, as before
        var tier = tierPrice(s, q, unit);
        var each = tier !== null ? tier : unit.value;
        priceText = hasBreaks ? formatMoney(unit, each) + ' each' : formatMoney(unit, each * q);
      }
      // the real button on the page shows the same total
      this.decorateMain(t, priceText);
      if (this.btnPrice.textContent !== priceText) this.btnPrice.textContent = priceText;
      this.btn.classList.toggle('pdp-bar__btn--noprice', !priceText);

      this.btn.disabled = !!t.el.disabled;
      this.btn.classList.toggle('pdp-bar__btn--notify', t.notify);
      if (t.notify || t.el.getAttribute('aria-haspopup') === 'dialog') this.btn.setAttribute('aria-haspopup', 'dialog');
      else this.btn.removeAttribute('aria-haspopup');
    }
  };

  /* Unit price of the selected variant: the visible price text (follows WSAIO rewrites),
     falling back to the numeric content attribute the theme puts on the price span. */
  PdpBar.prototype.unitPrice = function (s) {
    var el = s.querySelector('#ProductPrice-' + this.sid);
    var p = el ? parseMoney(textWithoutHidden(el)) : null;
    if (!p && el) {
      var v = parseFloat(el.getAttribute('content'));
      if (!isNaN(v)) p = { value: v, before: '$', after: '' };
    }
    if (p) this._lastUnit = p;          // remember the last good price
    return p || this._lastUnit || null; // a brief re-render never blanks the total
  };

  /* "Add to cart · $109.68" on the real button.
     Other scripts rewrite this button's text (theme.js on every variant change, the AJAX cart's
     "Added!" message, apps), and anything put INSIDE it gets wiped. So the total is an attribute
     shown by CSS (::after, see pdp-sticky-bar.css): text rewrites leave attributes alone.
     aria-label keeps the spoken name complete ("Add to cart, total $109.68"). */
  PdpBar.prototype.decorateMain = function (t, priceText) {
    var btn = t && t.el;
    if (!btn || t.notify) return;
    // clean up earlier versions (span / attribute + CSS ::after)
    var old = btn.querySelector('.pdp-btn-total');
    if (old) old.remove();
    if (btn.hasAttribute('data-pdp-total')) btn.removeAttribute('data-pdp-total');
    if (btn.hasAttribute('data-pdp-label')) { btn.removeAttribute('aria-label'); btn.removeAttribute('data-pdp-label'); }

    // Only the plain button text is touched, and only when it is the normal label
    // (Add to cart / Pre-Order). "Adding…", "Added!", "Unavailable" etc. are left alone, and the
    // real label comes back with the total on the next sync. No pseudo-elements, no child nodes,
    // so theme / app button styles can't overlap it.
    var base = baseLabel(btn);
    if (btn.disabled || !priceText || !/add to cart|pre-?order/i.test(base)) return;
    var want = base + TOTAL_SEP + priceText;
    if (btn.textContent.replace(/\s+/g, ' ').trim() === want) return;

    // safety valve: count only rewrites that UNDID our last text (a fight with another script);
    // normal quantity / colour changes never trip it
    var now = Date.now();
    var current = btn.textContent.replace(/\s+/g, ' ').trim();
    var undone = this._lastWant && current !== this._lastWant;
    this._writes = (this._writes || []).filter(function (ts) { return now - ts < 3000; });
    if (undone) this._writes.push(now);
    if (this._writes.length >= 8) {
      if (!this._warned) {
        this._warned = true;
        console.warn('[pdp-bar] Another script keeps resetting the Add to cart text; the total on that button is paused.');
      }
      return;
    }
    this._lastWant = want;
    btn.textContent = want;
  };

  /* ---------- bar → real form ---------- */
  PdpBar.prototype.setQty = function (value) {
    var v = parseInt(value, 10);
    if (!(v > 0)) v = 1;
    this.qty.value = v;
    var mq = this.mainQty();
    if (mq) {
      mq.value = v;
      mq.dispatchEvent(new Event('input', { bubbles: true }));
      mq.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  PdpBar.prototype.bindEvents = function () {
    var self = this;

    if (this.select) {
      this.select.addEventListener('change', function () {
        var radio = document.getElementById(self.select.value);
        if (radio && !radio.checked) radio.click(); // <variant-selects> handles the change
        self.select.selectedIndex = 0;              // the closed select always reads "Change"
      });
    }

    this.bar.addEventListener('click', function (e) {
      var step = e.target.closest('[data-pdp-bar-step]');
      if (step) {
        var cur = parseInt(self.qty.value, 10) || 1;
        self.setQty(Math.max(1, cur + parseInt(step.getAttribute('data-pdp-bar-step'), 10)));
        return;
      }
      if (e.target.closest('[data-pdp-bar-btn]')) {
        self.setQty(self.qty.value);
        var t = self.target();
        if (t && t.el && !t.el.disabled) t.el.click();
      }
    });

    this.qty.addEventListener('change', function () { self.setQty(self.qty.value); self.queueSync(); });
    this.qty.addEventListener('input', function () {
      var v = parseInt(self.qty.value, 10);
      if (v > 0) { var mq = self.mainQty(); if (mq) mq.value = v; }
      self.queueSync(); // live total in the button
    });
    var onBp = this.queueSync.bind(this);
    if (this.narrow.addEventListener) this.narrow.addEventListener('change', onBp);
    else if (this.narrow.addListener) this.narrow.addListener(onBp);

    // real form → bar: variant re-renders, WSAIO price rewrites, stepper clicks, availability
    var s = this.section();
    if (s) {
      new MutationObserver(this.queueSync.bind(this)).observe(s, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'checked', 'disabled', 'hidden']
      });
      s.addEventListener('change', this.queueSync.bind(this));
      s.addEventListener('input', this.queueSync.bind(this));
      s.addEventListener('click', function (e) {
        if (e.target.closest('.product-form__item--quantity, .js-qty__adjust, .qty__btn')) setTimeout(self.queueSync.bind(self), 0);
      });
      s.addEventListener('keyup', function (e) {
        if (e.target.closest('.product-form__item--quantity')) self.queueSync();
      });
    }
  };

  function boot() {
    if (!('IntersectionObserver' in window)) return; // bar simply never shows; real button still works
    document.querySelectorAll('[data-pdp-bar]').forEach(function (bar) {
      if (bar.__pdpBar) return;
      bar.__pdpBar = new PdpBar(bar);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();